// Vue
import { PropType } from "vue";

// ///////////////////
// Common
// ///////////////////

const inputLabelProp = {
  label: {
    type: String,
    default: "",
    required: true,
  },
};

const inputNameProp = {
  name: {
    type: String,
    default: "",
    required: true,
  },
};

const inputDisabledProp = {
  disabled: {
    type: Boolean,
    default: false,
  },
};

const inputHoverProp = {
  hover: {
    type: Boolean,
    default: false,
  },
};

// ///////////////////
// Checkbox
// ///////////////////

const checkboxCheckedProp = {
  checked: {
    type: [Boolean, String] as PropType<boolean | "indeterminate">,
    required: true,
    default: false,
    validator: (value: boolean | "indeterminate") => {
      return typeof value === "boolean" || value === "indeterminate";
    },
  },
};

const checkboxProp = {
  // Common
  ...inputDisabledProp,
  ...inputHoverProp,
  ...inputLabelProp,
  ...inputNameProp,

  // Custom
  ...checkboxCheckedProp,
};

// ///////////////////
// Radio Button
// ///////////////////

const radioButtonCheckedProp = {
  checked: {
    type: Boolean,
    required: true,
    default: false,
  },
};

const radioButtonValueProp = {
  value: {
    type: [String, Number],
    required: true,
    default: "",
  },
};

const radioButtonProp = {
  // Common
  ...inputDisabledProp,
  ...inputHoverProp,
  ...inputLabelProp,
  ...inputNameProp,

  // Custom
  ...radioButtonCheckedProp,
  ...radioButtonValueProp,
};

export {
  // Checkbox
  checkboxProp,
  checkboxCheckedProp,

  // Radio Button
  radioButtonProp,
};
